/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FertilizersInputs */

const vi_nav_fertilizers = /** @type {(inputs: Nav_FertilizersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón`)
};

/**

* @param {Nav_FertilizersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_fertilizers = /** @type {((inputs?: Nav_FertilizersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FertilizersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_fertilizers(inputs)
});